<template>
  <div class="ma-4">
    <CreateCalendar v-if="!showCalendar" @newCalendar="newCalendar()" />
    <v-row v-if="showCalendar">
      <v-col md="2">
        <v-card>
          <v-card-title class="justify-center primary--text">New Event</v-card-title>
          <v-container>
            <v-text-field v-model="NewEvent.Name" label="Name of Event" dense></v-text-field>
            <v-text-field v-model="NewEvent.Day" label="Day of Event" dense type="number"></v-text-field>
            <v-select
              v-model="NewEvent.Month"
              :items="Calendar.Months"
              item-text="Name"
              item-value
              label="Month"
            ></v-select>
            <v-text-field v-model="NewEvent.Year" label="Year of Event" dense type="number"></v-text-field>
          </v-container>
          <v-card-actions class="justify-center">
            <v-btn class="secondary mb-3" @click="AddEvent()">Add Event</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="my-2" flat>
          <v-card-actions class="justify-center">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" @click="EditCalendar()" v-on="on" class="mx-1">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit Calendar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="red darken-1" dark @click="deleteDialog=true" v-on="on" class="mx-1">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete Calendar</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col md="10">
        <v-row align="center" justify="center">
          <v-col class="pa-0 ma-1">
            <v-card>
              <v-row>
                <v-btn class="my-3 ml-6" color="secondary" @click="subtractDays()">
                  <v-icon dark>mdi-minus</v-icon>
                </v-btn>
                <v-col md="1">
                  <v-text-field v-model="Day" label="Day" dense type="number"></v-text-field>
                </v-col>

                <v-btn class="my-3" color="secondary" @click="addDays()">
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-card-title class="primary--text">{{ViewMonth.Name}}</v-card-title>
                <v-spacer></v-spacer>

                <v-btn class="my-3 mr-3" color="secondary" @click="lastmonth()">
                  <v-icon dark>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn class="my-3 mr-6" color="secondary" @click="nextmonth()">
                  <v-icon dark>mdi-arrow-right</v-icon>
                </v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="day in Calendar.DayOfWeek" :key="day.Name" class="pa-0 ma-1">
            <v-card class="caption text-center primary--text">{{day.Name}}</v-card>
          </v-col>
        </v-row>
        <v-row v-for="x in weeks" :key="x">
          <v-col v-for="y in Daysinweek" :key="y" class="pa-0 ma-1">
            <v-card v-if="x==1 &&  ViewMonth.StartDay>=y" color="grey lighten-2">
              <v-responsive :aspect-ratio="4/3"></v-responsive>
            </v-card>
            <v-card
              v-if="(ViewMonth.Days>=y+((x-1)*Daysinweek)-ViewMonth.StartDay && ViewMonth.StartDay<y) || (ViewMonth.Days  >=y+((x-1)*Daysinweek) - ViewMonth.StartDay && x!==1)"
            >
              <v-responsive :aspect-ratio="4/3">
                <v-row class="px-4 py-1" justify="end">
                  <v-avatar
                    color="primary"
                    size="24"
                    v-if="y+((x-1)*Daysinweek)-ViewMonth.StartDay==Calendar.CurrentDay && Calendar.CurrentMonth==ViewMonth.order"
                  >
                    <span class="white--text">{{y+((x-1)*Daysinweek)- ViewMonth.StartDay}}</span>
                  </v-avatar>
                  <span
                    class="secondary--text"
                    v-if="(y+((x-1)*Daysinweek-ViewMonth.StartDay)!==Calendar.CurrentDay && Calendar.CurrentMonth==ViewMonth.order) || Calendar.CurrentMonth!==ViewMonth.order"
                  >{{y+((x-1)*Daysinweek)-ViewMonth.StartDay}}</span>
                </v-row>
                <v-row
                  v-for="event in GetEvents(y+((x-1)*Daysinweek)-ViewMonth.StartDay, ViewMonth.order)"
                  :key="event.name"
                  class="mx-2"
                >
                  <v-card outlined class="my-1">
                    <v-btn
                      x-small
                      class="py-0 px-1 caption"
                      @click="EditEvent(event)"
                    >{{event.Name}}</v-btn>
                  </v-card>
                </v-row>
              </v-responsive>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-dialog
        v-model="EditEventDialog"
        hide-overlay
        transition="dialog-bottom-transition"
        max-width="600px"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="EditEventDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit Event</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="DeleteEvent()">
                <span class="black--text">Delete</span>
              </v-btn>
              <v-btn dark text @click="UpdateEvent()">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="NewTown" class="pa-4">
            <v-text-field v-model="CurrentEvent.Name" label="Name" outlined></v-text-field>
            <v-text-field v-model="CurrentEvent.Day" label="Day" outlined></v-text-field>
            <v-text-field v-model="CurrentEvent.Month" label="Month" outlined></v-text-field>
            <v-text-field v-model="CurrentEvent.Year" label="Year" outlined></v-text-field>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Delete {{Calendar.Name}}?</v-card-title>
          <v-card-text>If you click Delete {{Calendar.Name}} will be removed for ever.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="deleteDialog = false">Cancel</v-btn>
            <v-btn color="red darken-1" text @click="deleteCalendar()">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";
import { store } from "@/fb";

import CreateCalendar from "@/components/CreateCalendar";

export default {
  components: { CreateCalendar },
  data: () => ({
    ViewMonth: { Days: 31, order: 0 },
    Day: 1,
    NewEvent: {},
    Calendar: { Months: [], DayOfWeek: [], Events: [] },
    playerid: null,
    deleteDialog: false,
    EditEventDialog: false,
    CurrentEvent: {},
    showCalendar: false,
  }),
  computed: {
    weeks: function () {
      if (typeof this.ViewMonth.StartDay == "undefined") {
        return Math.ceil(this.ViewMonth.Days / this.Daysinweek);
      }
      return Math.ceil(
        parseInt(this.ViewMonth.StartDay + parseInt(this.ViewMonth.Days)) /
          this.Daysinweek
      );
    },
    Daysinweek: function () {
      let DaysinWeek = this.Calendar.DayOfWeek.length;
      if (DaysinWeek == 0) {
        return 1;
      }
      return DaysinWeek;
    },
  },
  methods: {
    nextmonth() {
      let index = this.ViewMonth.order + 1;
      if (index >= this.Calendar.Months.length) {
        index = 0;
      }
      let StartDay =
        this.ViewMonth.StartDay +
        (parseInt(this.ViewMonth.Days) % this.Daysinweek);
      if (StartDay > 6) {
        StartDay = StartDay - 7;
      }
      this.ViewMonth = this.Calendar.Months[index];
      this.ViewMonth.order = index;
      this.ViewMonth.StartDay = StartDay;
    },
    lastmonth() {
      let EndDay = this.ViewMonth.StartDay;
      if (EndDay == 0) {
        EndDay = 7;
      }
      let index = this.ViewMonth.order - 1;
      if (index < 0) {
        index = this.Calendar.Months.length - 1;
      }
      this.ViewMonth = this.Calendar.Months[index];
      this.ViewMonth.order = index;

      let Remainder = this.ViewMonth.Days % this.Daysinweek;
      let StartDay = EndDay - Remainder + 1;
      if (StartDay < 1) {
        StartDay = 7 + StartDay;
      }

      this.ViewMonth.StartDay = StartDay - 1;
    },
    subtractDays() {
      let day = this.Calendar.CurrentDay - parseInt(this.Day);
      let StartDay = this.Calendar.CurrentMonthStartDay;

      if (day < 1) {
        let index = this.Calendar.CurrentMonth - 1;
        if (index < 0) {
          index = this.Calendar.Months.length - 1;
        }
        this.Calendar.CurrentDay = this.Calendar.Months[index].Days;
        let newday = day + parseInt(this.Calendar.CurrentDay);
        this.Calendar.CurrentDay = newday;
        let EndDay = this.ViewMonth.StartDay;
        if (EndDay == 0) {
          EndDay = 7;
        }
        this.ViewMonth = this.Calendar.Months[index];
        this.ViewMonth.order = index;
        this.Calendar.CurrentMonth = index;

        let Remainder = this.ViewMonth.Days % this.Daysinweek;
        let StartDay = EndDay - Remainder + 1;
        if (StartDay < 1) {
          StartDay = 7 + StartDay;
        }

        this.ViewMonth.StartDay = StartDay - 1;
      } else {
        this.Calendar.CurrentDay = day;
      }
      this.Calendar.CurrentMonthStartDay = StartDay;
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Calendar: this.Calendar });
      this.$forceUpdate();
    },
    addDays() {
      let day = this.Calendar.CurrentDay + parseInt(this.Day);
      let StartDay =
        this.ViewMonth.StartDay +
        (parseInt(this.ViewMonth.Days) % this.Daysinweek);
      if (StartDay > 6) {
        StartDay = StartDay - 7;
      }

      if (day > this.Calendar.Months[this.ViewMonth.order].Days) {
        let newday = day - this.Calendar.CurrentDay;

        let index = this.Calendar.CurrentMonth + 1;
        if (index >= this.Calendar.Months.length) {
          index = 0;
        }
        this.ViewMonth = this.Calendar.Months[index];
        this.ViewMonth.order = index;
        this.ViewMonth.StartDay = StartDay;
        this.Calendar.CurrentMonth = index;
        this.Calendar.CurrentDay = newday;
      } else {
        this.Calendar.CurrentDay = day;
      }
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Calendar: this.Calendar });
      this.$forceUpdate();
    },
    GetEvents(cday, cmonth) {
      return this.Calendar.Events.filter(
        (e) => e.Day == cday && e.Month == cmonth
      );
    },
    EditCalendar() {
      this.$router.push({
        name: "EditCalendar",
        params: { id: store.CurrentCampaign.id },
      });
    },
    deleteCalendar() {
      this.deleteDialog = false;
      this.showCalendar = false;
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Calendar: null });
    },
    AddEvent() {
      let index = this.Calendar.Months.findIndex(
        (i) => i.Name === this.NewEvent.Month
      );
      this.Calendar.Events.push({
        Name: this.NewEvent.Name,
        Day: this.NewEvent.Day,
        Month: index,
        Year: this.NewEvent.Year,
      });
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Calendar: this.Calendar });
      this.NewEvent.Name = null;
      this.NewEvent.Day = null;
      this.NewEvent.Month = null;
      this.NewEvent.Year = null;
    },
    EditEvent(event) {
      this.CurrentEvent = event;
      this.EditEventDialog = true;
    },
    UpdateEvent() {
      this.EditEventDialog = false;
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Calendar: this.Calendar });
    },
    DeleteEvent() {
      this.EditEventDialog = false;
      let index = this.Calendar.Events.findIndex(
        (e) => e === this.CurrentEvent
      );
      this.Calendar.Events.splice(index, 1);
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Calendar: this.Calendar });
    },
    newCalendar() {
      this.showCalendar = true;
      this.$forceUpdate();
    },
  },
  firestore() {
    this.$bind(
      "campaign",
      db.collection("campaigns").doc(store.CurrentCampaign.id)
    ).then((campaign) => {
      if (campaign.Calendar != null) {
        this.Calendar = campaign.Calendar;
        this.ViewMonth =
          campaign.Calendar.Months[campaign.Calendar.CurrentMonth];
        this.ViewMonth.order = campaign.Calendar.CurrentMonth;
        this.ViewMonth.StartDay = campaign.Calendar.CurrentMonthStartDay;
        this.showCalendar = true;
      } else {
        this.showCalendar = false;
      }
    });
  },
  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
  },
};
</script>